import React from "react";
import styled from "styled-components";
import {borderColour, subduedTextColour} from "../../../style/styleConsts";

const Container = styled.div`
    display: inline-block;
    color: ${subduedTextColour};
    background-color: ${borderColour};
    font-size: 24px;
    padding: 0 8px;
    border-radius: 5px;
`;

export const DeactivatedLabel = ({active}) => {
    if (active) return null;

    return <Container className="t-deactivated-label">DEACTIVATED</Container>;
};